module.exports = __webpack_public_path__ + "img/liuwen.d6e2ff49.png";